export class CodePrestation {
  constructor(
    public Cle: number,
    public Code: string,
    public Libelle: string
  ) { }
}

export interface ICodePrestation {
  Cle: number,
  Code: string,
  Libelle: string
}
